export namespace SuperPowerConfig {

    export class SelectInfo {
        name: string;
        prefabName: string;
        talkList: string[];
    }

    export const SelectConfig: SelectInfo[] = [
        {
            name: "我不想看广告",
            prefabName: "SuperPowerSelect1",
            talkList: ['真拿你没办法，那就送你一些免广告卡吧'],
        },
        {
            name: "我想娶老婆",
            prefabName: "SuperPowerSelect2",
            talkList: ['请你选择一位心仪的女孩子吧，我会为你们安排好姻缘'],
        },
        {
            name: "我要富可敌国",
            prefabName: "SuperPowerSelect3",
            talkList: ['这好办，给你100亿够了吧，比财政大臣管的钱还多'],
        },
        {
            name: "我要做大官",
            prefabName: "SuperPowerSelect4",
            talkList: ['小意思啦，让你连升三级官阶'],
        },
        {
            name: "我要超品神器",
            prefabName: "SuperPowerSelect5",
            talkList: ['任你挑选三件，最多三件哟，不要太贪心，快选吧'],
        }, 
        {
            name: "我要当武林盟主",
            prefabName: "SuperPowerSelect6",
            talkList: ['给你一个武林盟主令牌，以后你就是武林盟主啦'],
        },
        {
            name: '我要年轻十岁',
            prefabName: 'SuperPowerSelect7',
            talkList: ['洒洒水啦，未来十年你的样貌都不会改变'],
        }, 
        {
            name: '我要武功盖世',
            prefabName: 'SuperPowerSelect8',
            talkList: ['送你一本武功秘籍，你练会了就武功盖世啦'],
        },
        {
            name: '我要再许10个愿望',
            prefabName: 'SuperPowerSelect9',
            talkList: ['你搁我这卡BUG呢，年轻人要知足，给你1个亿吧，就这样啦，我们下次再会'],
        },
        {
            name: "我要当皇帝",
            prefabName: "SuperPowerSelect10",
            talkList: ['你本是皇家血脉，这是你父皇给你的考验，你就慢慢等吧，给你1个亿，你能活到你爹百年之后啦'],
        },
    ];
    
}